module.exports = __webpack_public_path__ + "static/media/logo.a0185b04.svg";